module.exports = __webpack_public_path__ + "static/media/download.d1dfd619.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/download.svg
// module id = 859
// module chunks = 0